import * as yup from 'yup';

import { convertYupErrorToMessagesObject } from '@shared/utils/validation.utils';
import { usernameSchema } from '@shared/utils/validation.schemas';
import {
    fullNameSchema, phoneSchema,
    companyNameSchema,
    companySizeSchema,
    passwordSchema,
} from '../auth.validation';

export const signUpSinglePageSchema = async () => yup.object()
    .shape({
        companyName: companyNameSchema,
        companySize: companySizeSchema,
        name: fullNameSchema,
        username: usernameSchema,
        password: await passwordSchema(),
        phone: phoneSchema,
    });


export const validateUsername = ({
    data,
}) => usernameSchema.validate(data, { abortEarly: false }).catch(
    error => Promise.reject(convertYupErrorToMessagesObject(error)),
);
